import React from 'react'
import Svg from './Svg'
export const SvgMagnifyingGlass = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M.324 20.521a1.123 1.123 0 000 1.578l1.578 1.578a1.125 1.125 0 001.578 0l6.144-6.141c1.432.873 3.101 1.406 4.906 1.406 5.229 0 9.47-4.242 9.47-9.47 0-5.23-4.242-9.471-9.47-9.471-5.229 0-9.471 4.242-9.471 9.471 0 1.804.532 3.472 1.409 4.905L.324 20.521zM8.216 9.473a6.315 6.315 0 1112.628 0 6.315 6.315 0 01-12.628 0z" />
  </Svg>
))
SvgMagnifyingGlass.isIcon = true
export default SvgMagnifyingGlass
